import React from 'react';
import styled from 'styled-components/macro';
import { NotificationType } from '../../context/appContext';
import { DeviceSize } from '../basic/DeviceSize';
import { Body2 } from '../common/Text';
import { infoFilledIcon } from '../../assets';
import { notificationColors } from '../Notifications';

const Container = styled.div<{
  type: NotificationType;
  margin?: React.CSSProperties['margin'];
  width?: React.CSSProperties['width'];
}>`
  width: ${({ width }) => width || '600px'};
  margin: ${({ margin }) => margin || '40px 0'};
  background-color: ${({ type }) => notificationColors[type]};
  padding: 20px 24px;
  border-radius: 16px;

  button {
    margin-top: 20px;
  }

  @media ${DeviceSize.desktopS} {
    width: 100%;
  }
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

interface InfoBoxProps {
  type: NotificationType;
  message: string;
  margin?: React.CSSProperties['margin'];
  width?: React.CSSProperties['width'];
  button?: React.ReactElement;
}

const InfoBox: React.FC<InfoBoxProps> = ({ type, message, margin, width, button }) => {
  return (
    <Container type={type} margin={margin} width={width}>
      <MessageContainer>
        <img src={infoFilledIcon} alt="" />
        <Body2 margin={'0'}>{message}</Body2>
      </MessageContainer>
      {button}
    </Container>
  );
};

export default InfoBox;
